const getApiUrl = () => {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'https://oci.apidev.djcer.com.br/services/v1/djcer';
  }
  return `https://oci.apidev.djcer.com.br/services/v1/djcer`;
};

export const environment = {
  apiURL: getApiUrl(),
  appTitle: 'DJCer DEV',
  viacepURL: 'https://viacep.com.br/ws/',
  cnpjLookupURL: 'https://publica.cnpj.ws/cnpj/'
};
